"use client";

import { useState } from "react";
import { ArrowRight, Play, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const headline = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const copy = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const actions = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const index = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="16550" id="videohero" className="relative min-h-[80vh] flex items-center overflow-hidden bg-primary text-white !bg-[url(https://nomocowp.10web.cloud/wp-content/uploads/2026/06/bghero.png)]">
      {}
      <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover z-0">
        <source src="https://nomocowp.10web.cloud/wp-content/uploads/2026/06/bgvideo.mp4" type="video/mp4" />
      </video>

      {}
      <div className="absolute inset-0 bg-primary/60 backdrop-blur-[2px] z-1" />

      <div className="relative z-10 mx-auto w-full max-w-[1280px] px-6 md:px-8 py-24 md:py-32">
        <div ref={index.ref} className="font-mono text-[10px] font-bold tracking-[0.2em] text-white/70 mb-12 flex items-center gap-4" style={{
        opacity: index.isVisible ? 1 : 0,
        transform: index.isVisible ? "translateY(0)" : "translateY(10px)",
        transition: "opacity 600ms cubic-bezier(0.16, 1, 0.3, 1), transform 600ms cubic-bezier(0.16, 1, 0.3, 1)"
      }}>
          
          <div className="h-px w-12 bg-white/30" />
          <span className="uppercase !h-[20px]">Comfort, Confidence and Clarity<br /><br /></span>
        </div>

        <div className="max-w-3xl">
          <h1 ref={headline.ref} className="font-default font-bold text-white" style={{
          maxWidth: "559px",
          fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
          letterSpacing: "-0.02em",
          lineHeight: 1.1,
          textShadow: "0 2px 10px rgba(0,0,0,0.2)",
          opacity: headline.isVisible ? 1 : 0,
          transform: headline.isVisible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 600ms cubic-bezier(0.16, 1, 0.3, 1)"
        }}><span style={{
            fontWeight: 'normal'
          }}><i>NoMoCo </i></span>Pillow Support System</h1>

          <p ref={copy.ref} className="mt-8 max-w-[52ch] text-white/90" style={{
          fontSize: "1.125rem",
          lineHeight: 1.6,
          opacity: copy.isVisible ? 1 : 0,
          transform: copy.isVisible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 600ms cubic-bezier(0.16, 1, 0.3, 1) 100ms, transform 600ms cubic-bezier(0.16, 1, 0.3, 1) 100ms"
        }}>NoMoCo Inc.'s memory foam pillow support system products help patients complete brain imaging studies in research centers, hospitals or clinical settings with maximum comfort and with minimal movement.</p>

          <div ref={actions.ref} className="mt-12 flex flex-wrap items-center gap-6" style={{
          opacity: actions.isVisible ? 1 : 0,
          transform: actions.isVisible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 600ms cubic-bezier(0.16, 1, 0.3, 1) 200ms, transform 600ms cubic-bezier(0.16, 1, 0.3, 1) 200ms"
        }}>
            <Link to="/OrderPage">
              <Button className="h-auto px-8 py-4 rounded-lg bg-white text-primary hover:bg-white/90 font-bold uppercase tracking-[0.05em] text-xs transition-transform hover:-translate-y-0.5 shadow-lg">
                Request a Quote
              </Button>
            </Link>
            
            <Button onClick={() => setIsVideoOpen(true)} variant="outline" className="h-auto px-8 py-4 rounded-lg border-white/30 bg-white/10 text-white hover:bg-white/20 font-bold uppercase tracking-[0.05em] text-xs transition-transform hover:-translate-y-0.5 shadow-lg flex items-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-play fill-current" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/Hero.tsx|sig:iuq6jg" data-ast-start="4127" data-ast-end="4160"><path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"></path></svg>Watch DEMO</Button>

            <Link to="/ProductPage">
              <Button variant="ghost" className="h-auto px-4 py-4 rounded-lg text-white hover:bg-white/10 font-bold uppercase tracking-[0.05em] text-xs transition-transform hover:-translate-y-0.5">View Product<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 h-4 w-4" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/Hero.tsx|sig:xiqe8" data-ast-start="4491" data-ast-end="4530"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      {isVideoOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8">
          <div className="absolute inset-0 bg-black/90 backdrop-blur-md" onClick={() => setIsVideoOpen(false)} />
          <div className="relative w-full max-w-5xl aspect-video bg-black rounded-lg overflow-hidden shadow-2xl z-10">
            <Button variant="ghost" size="icon" className="absolute top-4 right-4 text-white hover:bg-white/20 rounded-lg z-20" onClick={() => setIsVideoOpen(false)}>
              <X className="h-6 w-6" />
            </Button>
            <iframe src="https://www.youtube.com/embed/MrOV75J3KvQ?si=_BrzU-wMrYTr0yFU&autoplay=1" title="NoMoCo Product Video" className="w-full h-full border-0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
          </div>
        </div>}
    </section>;
}